<div  *ngIf="loginCheck" class="siteHome">
  <div class="mainCon">
    <div class="leftCon">
      <div class="left_content">
        <img src="../../../assets/images/login_bg.png" class="leftConImage" alt="" />
        <!-- <h3 class="left_text" style="margin-top: 80px">
          Asset Health & Predictive
          <h3 style="color: #ffff;
          margin-top: 8px;
          position: relative;
          left: 88px;
          font-size: 32px;
          font-weight: 500;">Maintenance</h3>
          <hr  style="width:100%;text-align:left;margin-left:8px; margin-top: 0px;">
         </h3> -->
        <!-- <span class="login_desc"
          >Reduce unplanned downtime, Improve asset <br>
          <span style="color: #ffff;
          font-size: 20px;
          margin-top: 8px;
          position: absolute;
          left: 228px;">availability, and OLE</span>
      </span> -->
        <br />
        <br />
      </div>
    </div>
    <div class="rightCon" style="height: 110%;">
      <div class="login_card">
        <div class="imgcon">
          <img src="../../../assets/images/predict.ai logo.svg" style="height: 45px" />
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="login(loginForm)" method="post"
        action="">
          <div class="inputcon">
            <label>Username</label>
            <input
              type="text"
              id="username"
              #username
              placeholder="Username or Useremail"
              formControlName="useremail"
              autocomplete="nope"
              maxlength="40"
            />
            <div
              *ngIf="
                loginForm.get('useremail')?.touched &&
                loginForm.get('useremail')?.invalid
              "
              class="text-danger"
            >
              <div
                *ngIf="loginForm.get('useremail')?.errors?.required"
                class="errorTextInput"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" />
               Username is required.
              </div>
              <div
                *ngIf="loginForm.get('useremail')?.errors?.email"
                class="errorTextInput"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" /> 
              Invalid Username
              </div>
            </div>
          </div>

          <div class="inputcon">
            <label>Password</label>
            <input
              id="password"
              #password
              autocomplete="new-password"
              [type]="hide ? 'password' : 'text'"
              placeholder="Password"
              formControlName="password"
              maxlength="40"
              minlength="8"
              (cut)="$event.preventDefault()" (copy)="$event.preventDefault()" (paste)="$event.preventDefault()">
              <mat-icon class="placeholder" (click)="passwordView()" class="password_view" >{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            <div
              *ngIf="
                loginForm.get('password')?.touched &&
                loginForm.get('password')?.invalid
              "
              class="text-danger"
            >
              <div
                *ngIf="loginForm.get('password')?.errors?.required"
                class="errorTextPawwsord"
              >
              <img src="../../../assets/images/alert-f-svgrepo-com.svg" style="height: 15px; position: relative; bottom: 2px;" /> 
              Password is required.
              </div>
            </div>
          </div>
          <div class="row login_extra">
            <div class="col text-left">
              <label class="checkbox"
                ><input
                  formControlName="remember"
                  name="remember"
                  type="checkbox" />
                 <span style="position: relative; bottom: 2px; left: 3px;">Remember me</span></label>
            </div>
            <div class="col text-right">
              <a routerLink="/forgot" class="font-size-10p forgotPassword">Forgot Password ?</a>
            </div>
          </div>
          <div class="line"></div>
          <div class="">
            <p *ngIf="loading" class="load">Loading...</p>
            <button type="submit" class="btn" *ngIf="!loading">Sign In</button>
          </div>
          <br>
          <br>
          <p style="position: relative; top: 30px; right: 28px">
          <a class="cursor-pointer">Copyright</a> <span class="copyright">@ 2023 BLP Industry.AI. All
            rights reserved</span>
        </p>
        </form>
      </div>
    </div>
  </div>
</div>
<app-loader *ngIf="!loginCheck"></app-loader>
